import classNames from "classnames"
import { includes, isNumber, map } from "lodash-es"
import numeral from "numeral"

import styles from "./index.module.scss"
import { SimpleTableListItemProp, SimpleTableListProps } from "./types"

export default function SimpleTableList(props: SimpleTableListProps) {
  const fields: string[] = map(props.fields, "field")

  const classNameMap: Map<string, string> = new Map<string, string>()

  props.fields.map((item) => classNameMap.set(item.field, item.className ?? ""))

  // 空数据设置
  let emptyData

  if (props.data.length === 0 && props.emptyData) {
    emptyData = (
      <SimpleTableListItem
        classNameMap={classNameMap}
        fields={fields}
        key={"head-0"}
        values={props.emptyData}
      />
    )
  }

  let thead

  if (!props.noHead) {
    thead = (
      <thead>
        <tr>
          {props.fields.map((item) => {
            return (
              <th
                className={item.className}
                key={`${item.field}`}
                style={{ paddingRight: 0 }}
              >
                {item.title}
              </th>
            )
          })}
        </tr>
      </thead>
    )
  } else {
    thead = <></>
  }

  // 最终渲染输出
  return (
    <table className={`${styles.table} ${props.className}`}>
      {thead}
      <tbody>
        {props.data.map((values: any, index: number) => {
          return (
            <SimpleTableListItem
              classNameMap={classNameMap}
              fields={fields}
              key={index + ""}
              thousandsSplitFields={props.thousandsSplitFields || []}
              values={values}
            />
          )
        })}
        {emptyData}
      </tbody>
    </table>
  )
}

function SimpleTableListItem(props: SimpleTableListItemProp) {
  return (
    <tr>
      {props.fields.map((field, index) => {
        let val = props.values[field]

        if (includes(props.thousandsSplitFields, field) && isNumber(val)) {
          val = numeral(val).format("0,0")
        }
        return (
          <td
            className={classNames(props.classNameMap.get(field), "leading-5")}
            key={`td-${field}-${index}`}
            style={{ paddingRight: 0 }}
          >
            {val}
          </td>
        )
      })}
    </tr>
  )
}
